import { ReactNode } from "react";
import { useTitleSetter } from "../../utils/use-title-setter";
import { PageGrid } from "../grid";
import { DocumentPageGrid } from "../document-grid";
import { Breadcrumbs } from "../../../breadcrumbs";
import { BreadcrumbsOptions } from "../../../breadcrumbs/models/types";
import { useLocationSync } from "../../utils/use-location-sync";

type PageProps<Path extends string> = {
  children: ReactNode;
  title: string;
  breadcrumbsOptions: BreadcrumbsOptions<Path>;
};

export function Page<Path extends string>({
  breadcrumbsOptions,
  children,
  title,
}: PageProps<Path>) {
  useTitleSetter(title);
  useLocationSync();

  return (
    <>
      <Breadcrumbs breadcrumbsOptions={breadcrumbsOptions} />
      <main>{children}</main>
    </>
  );
}

Page.Grid = PageGrid;
Page.DocumentGrid = DocumentPageGrid;
